import gql from 'graphql-tag';

import blogPostFragment from '../fragments/blogPostFragment';

export const queryBlogPosts = gql`
  query blogPosts {
    blogPosts {
      ...blogPostFragment
    }
  }
  ${blogPostFragment}
`;
export default queryBlogPosts;
